// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__fOco-","tooltip":"IconButton_tooltip__1KmHj"};